import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useRepublishProposalTestIds = pathgen('useRepublishProposalTestIds');
export const useRepublishProposal = function useRepublishProposal() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t: editInPlaceTexts } = useLocaleKeys('agreementStudio.editInPlace');
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { draft, relationshipId } = param;
            await api.draft.save(draft);
            await api.relationship.republish(relationshipId);
        },
        withPageLoader: true,
        mutationName: 'republish-proposal',
        toasts: {
            successMessage: editInPlaceTexts.republishSuccessToast(),
            successTestId: useRepublishProposalTestIds.SuccessToast(),
            errorMessage: editInPlaceTexts.republishErrorToast(),
            errorTestId: useRepublishProposalTestIds.ErrorToast()
        },
        onSuccess: ()=>{
            queryClient.removeQueries({
                queryKey: [
                    QueryKeys.CustomPageText
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        republishProposal: mutate,
        isRepublishing: isLoading
    };
};
